module.exports = __webpack_public_path__ + "img/BT_send.328a9b48.svg";